import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { guidelineShape } from "../../lib/data_shapes";
import TypeHeader, { Title } from "../common/TypeHeader";
import GuidelineHeader from "./GuidelineHeader";
import RecommendationsList from "./RecommendationsList";
import SourceOfRecommendation from "./SourceOfRecommendation";

const Guideline = ({ data }) => {
  const { guideline, recommendations } = data;
  const { t } = useTranslation();
  return (
    <div>
      <TypeHeader className="tailwind-hidden md:block mb-3 mt-1" type="guideline" />
      <GuidelineHeader guideline={guideline} />
      <SourceOfRecommendation title={t("labels.about_guideline")} guideline={guideline} />
      <Title
        title={t("labels.recommendationsAndGoodPracticeStatements")}
        size="large"
        className="text-red-200 mt-8"
      />
      <RecommendationsList recommendations={recommendations} displaySource={false} />
    </div>
  );
};

Guideline.propTypes = {
  data: PropTypes.shape({
    "@id": PropTypes.string.isRequired,
    guideline: guidelineShape,
    recommendations: PropTypes.arrayOf(PropTypes.object),
  }),
};

Guideline.defaultProps = {
  data: {
    "@id": null,
    guideline: null,
    recommendations: [],
  },
};

export default Guideline;
